const compareByDepth = (a, b) => a.depth - b.depth;
export {
  compareByDepth
};
//# sourceMappingURL=compare-by-depth.js.map
